define.alias("shared/helpers/uuid", "media/helpers/uuid");